export const isEncryptedPdfError = (error: unknown): boolean => {
  return error instanceof Error && error.message.includes("is encrypted");
};
